import styled from 'styled-components';

export const CheckBox = styled.div`
  display: flex;
  align-items: center;
`;
export const Lable = styled.div`
  margin-inline-start: ${({ theme }) => theme.spacing.x3};
`;
